export default "__VITE_ASSET__CbPSs9HG__"